export class DocumentDetail {
    DocumentId: number;
    EmployeeId: number;
    UploadTime: string;
    PayperiodDate: string;
    SignStatus: number;
    SignStatusText: string;
    DocumentBytes: string;
    EmployeeConcern: string;
    NomCert: string;
    AlwaysShow: number;
    BatchId: number;
    Links: {
        SelfUri: string;
    };
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/documentDetail.model.ts